interface ConfigMap {
  feUrl: string
  apiUrl: string
  gaId: string
}

interface Env {
  [key: string]: ConfigMap;
}

const env: Env = {
  development: {
    feUrl: 'https://gener8.tech/iframes',
    apiUrl: 'http://localhost:9090',
    gaId: 'UA-140660651-1',
  },
  staging: {
    feUrl: 'https://gener8.tech/iframes',
    apiUrl: 'https://apollo.gener8.tech',
    gaId: 'UA-140660651-1',
  },
  production: {
    feUrl: 'https://gener8ads.com/iframes',
    apiUrl: 'https://apollo.gener8ads.com',
    gaId: 'UA-116933341-7',
  },
}

export default Object.freeze(env[process.env.NODE_ENV || 'development']);
